import { Link } from '@mui/material';
import { portalPaths } from '@provision/portal-routes';
import useSnackbarStore from 'src/store/snackbar';
import { useNavigateRoute } from 'src/utils/routing';

export const SmsSessionAlreadyOpenAlert = ({
  friendlyConversationId,
}: {
  friendlyConversationId: string;
}) => {
  const { navigate } = useNavigateRoute();
  const closeSnackbar = useSnackbarStore.use.closeSnackbar();

  return (
    <>
      This client already has a live SMS session in{' '}
      <Link
        component="button"
        type="button"
        color="inherit"
        underline="always"
        sx={{ verticalAlign: 'baseline', font: 'inherit' }}
        onClick={() => {
          closeSnackbar();
          navigate(portalPaths.conversation.full(friendlyConversationId));
        }}
      >
        conversation {friendlyConversationId}
      </Link>
      . End it there before starting a new one.
    </>
  );
};
